<template>
    <div class="list">
        <div id="list-dropdown">
            <select v-model="monthSelected" class="month" @change="onChange($event,'month')">
                <option v-for="(v,k) in lbl.date.month_full_arr"
                :key="k"
                :value="v.strvalue">
                    {{v.strtext}}
                </option>
            </select>
            <select v-model="yearSelected" class="year" @change="onChange($event,'year')">
                <!-- <option :value="currentYear - 2">{{ currentYear - 2 }}</option> -->
                <option :value="currentYear - 1">{{ currentYear - 1 }}</option>
                <option :value="currentYear">{{ currentYear }}</option>
            </select>
        </div>
        <div class="list-item"
            v-if="burnController.isLoaded && burnController.isHaveItem">
            <burn-item
                v-for="(burn, k) in burnController.list"
                :key="k"
                :index="k"
                :lbl="lbl"
                :burn="burn"
                :passcode_category="passcode_category"
                :surpriseCampaignId="surpriseCampaignId"
                :horoscope_category="horoscope_category"
                :controller="controller"
                :burnController="burnController"
            ></burn-item>
        </div>
        <div class="list-item list-empty"
            v-if="burnController.isLoaded && !burnController.isHaveItem">
            <div class="list-empty-content">
                <div class="empty-icon">
                    <img src="../../../assets/image/Tabbar/tabbar_history_inactive.png" />
                </div>
                <div class="empty-txt">{{lbl.history.list_empty}}</div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import BurnItem from './BurnListItem.vue';
//core
import BlobService from '@/core/BlobService/service/BlobService.js';
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//model
import { BurnPointConfigBuilder } from '@/core/History/model/BurnPointConfigModel.js';
//contorller
import { BurnPointController } from '@/module/History/controller/BurnPointController.js';
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: "BurnList",
    mixins: [
        ErrorApiMixin
    ],
    components: {
        BurnItem
    },
    props: {
        lbl: Object,
        localeCode: Number,
        controller: Object
    },
    data: function () {
        return {
            //select
            currentYear: null,
            monthSelected: null,
            yearSelected: null,
            passcode_category: [],
            //burn
            burnBuilder: new BurnPointConfigBuilder(),
            burnController: new BurnPointController(),
            //surprise box
            surpriseCampaignId: null,
            //horoscope
            horoscope_category: null,

            trackingService: new TrackingService(this),
            trackingEventCategory: 'history_page'
        };
    },
    created: async function () {
        this.initialPasscodeConfig();
        this.initailSurpriseConfig();

        this.horoscope_category = await this.getHoroScopeBlobConfig();

        this.monthSelected = this.getMonthNow();
        var currentYear = new Date().getFullYear();
        this.currentYear = this.localeCode == 1054
            ? currentYear + 543
            : currentYear;
        this.yearSelected = this.currentYear;

        //controller
        var year = this.localeCode == 1054
                ? this.yearSelected - 543
                : this.yearSelected;
        this.burnBuilder = this.burnBuilder.setStartDate(year, this.monthSelected);
        this.burnBuilder = this.burnBuilder.setEndDate(year, this.monthSelected);
        this.initialList();
        //error handler
        this.errorHandler = new ErrorHandler();
        this.alertModal = this.controller.alertModal;
        this.errorHandler.setAlertModal(this.alertModal);

        this.trackingService.event(this.trackingEventCategory, 'view_history_burn_point', null, null)
    },
    mounted: function () {
        this.initialControllerEvent();
        this.initialLoadMore();
    },
    beforeDestroy: function() {
        window.onscroll = null;
    },
    methods: {
        //method
        onChange: function (event,type) {
            if (type == 'month')
                this.monthSelected = event.target.value;

            if (type == 'year')
                this.yearSelected = event.target.value;


            var year = this.localeCode == 1054
                ? this.yearSelected - 543
                : this.yearSelected;

            this.burnController.changeMonth(year, this.monthSelected);

            this.trackingService.event(this.trackingEventCategory, 'click_burn_month_year', null, null)
        },
        initailSurpriseConfig: function(){
            BlobService.getSurpriseConfig()
            .then(res => {
                this.surpriseCampaignId = res.data.id;
            }).catch(err => {
                console.log(err);
            });
        },
        initialPasscodeConfig: function () {
            BlobService.getCategoryConfig()
                .then(res => {
                    if (res)
                    this.passcode_category = res.data;
                }).catch(err => {
                    this.hideLoading();
                    this.cbApiResponseError.sendCallback(err);
                });
        },
        initialList: function () {
            this.burnController.initialList(this.burnBuilder, this.controller);
        },
        initialControllerEvent: function () {
            this.burnController.cbApiResponseError.onCallback(err => {
                this.errorResponse(err, this.errorHandler);
            });
        },
        initialLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;

                if (bottomOfWindow)
                    this.burnController.loadMore();
            };
        },
        getMonthNow: function() {
            const today = new Date();
            return ("0" + (today.getMonth() + 1)).slice(-2);
        },
        //#region horoscope campaign
        getHoroScopeBlobConfig: function(){
            return new Promise((resolve) => {
                BlobService.getHoroscopeConfig()
                    .then(res => {
                        console.log('horo', res.data);
                        resolve(res.data.category);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        //#endregion horoscope campaign
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

#list-dropdown{
    @include baseSelect('../../../assets/icon/icon_dropdown.png');
    margin: 20px auto;
    text-align: center;

    select {
        font-size: 1.5rem;
        height: 45px;
        line-height: normal;
        border: 1px solid $a-gray-C4C4C4;
    }

    .month{
        width: calc(40% - 5px);
        margin-right: 5px;
    }
    .year{
        width: calc(40% - 5px);
        margin-left: 5px;
    }
}

.list-item {
    width: 100%;
    padding-bottom: 80px;

    &.list-empty {

        .list-empty-content {
            margin: 120px auto 0;
            text-align: center;

            @media(max-width: $max-width-mini-mobile){
                margin: 90px auto 0;
            }

            img{
                margin: auto;
            }
            .text-empty{
                color: $base-font-color;
                padding: 10px 0;
            }
            .empty-txt {
                padding-top: 5px;
                font-size: 1.5rem;
            }
        }
    }

    @media (max-width: $max-width-mini-mobile) {
        padding: 0 0 80px;
    }
}
</style>
